import { useMemo } from "react";

type UseQuantityOptionsProps = {
  product: {
    title: string;
    variantTitle: string;
    maxQuantity: number;
  };
  currentQuantity?: number;
};

export const useQuantityRestrictMessages = ({
  product,
  currentQuantity = 0,
}: UseQuantityOptionsProps) => {
  return useMemo(
    () => getQuantityRestrictMessages({ product, currentQuantity }),
    [currentQuantity, product]
  );
};

export const getQuantityRestrictMessages = ({
  product,
  currentQuantity = 0,
}: UseQuantityOptionsProps) => {
  const { title, variantTitle, maxQuantity } = product;
  if (maxQuantity === Infinity) return [];
  const messages = [
    `「${title} ${variantTitle}」は想定を超える注文をいただいており、現在商品の購入・追加を一時的に制限させていただいております。`,
  ];
  if (currentQuantity && maxQuantity < currentQuantity) {
    messages.push(
      `数量を減少させた場合、供給回復まで元の数量に戻すことができませんのでご注意ください。`
    );
  }

  return messages;
};
